import React, { useState } from 'react';
import { sizes } from '@sharefiledev/antd-config';
import { AiSparkles } from '@sharefiledev/icons';
import { qnaPiletOverlays } from '@sharefiledev/qna-pilet-sdk';
import { RID } from '@sharefiledev/sfplugin-resource-id';
import { Button, Flex, theme } from 'antd';
import { t } from 'utils/translate';
import { BetaTag } from '../common/BetaTag';
import { AiAssistantButtonProps } from './AIAssistantButton';

export const AssistantButtonComponent: React.FC<AiAssistantButtonProps> = props => {
	const { piletApi, resourceRID, forceClosePiralEvents } = props;
	const [_, setShowDrawer] = useState(false);
	const [isDisabled, setIsDisabled] = useState(false);
	const { token } = theme.useToken();

	const resourceType = RID.parse(resourceRID).entityType === 'lfile' ? 'lfile' : 'file';
	return (
		<Button
			icon={<AiSparkles size={16} />}
			onClick={() => {
				setIsDisabled(true);
				setShowDrawer(true);

				piletApi.showDrawer(qnaPiletOverlays.useSummarization, {
					async onCompleteInteraction(_resourceId: string) {
						setIsDisabled(false);
					},
					async onCancelInteraction() {
						setIsDisabled(false);
					},

					drawerProps: {
						style: {
							padding: token.marginXXS,
						},
						styles: {
							body: {
								paddingTop: token.marginSM,
								paddingRight: token.marginSM,
								paddingBottom: token.marginXXS,
								paddingLeft: token.marginSM,
							},
						},
						title: (
							<Flex
								style={{ gap: sizes.SM, fontSize: token.fontSizeHeading4 }}
								align="center"
							>
								{t('aiAssistant.title')}
								<BetaTag />
							</Flex>
						),
						width: 'min(85vw, 375px)',
						mask: false,
						maskClosable: false,
						destroyOnClose: false,
						keyboard: false,
					},
					...{
						disableHistoryEffects: true,
					},
					...{
						resourceType,
						params: {
							rid: resourceRID,
							forceClosePiralEvents,
						},
					},
				});
			}}
			data-testid="ai-assistant-button"
			disabled={isDisabled}
		>
			{t('aiAssistant.title')}
		</Button>
	);
};
